<script setup>
defineProps({
  search: { type: String, default: '' },
  channel: { type: String, default: '' },
  status: { type: String, default: '' },
  folder: { type: String, default: '' },
  availableChannels: { type: Array, default: () => [] },
  availableFolders: { type: Array, default: () => [] },
});

defineEmits([
  'update:search',
  'update:channel',
  'update:status',
  'update:folder',
]);

const STATUSES = [
  'attention',
  'failed',
  'unconfirmed',
  'delivery_attention',
  'ok',
  'idle',
  'never_ran',
  'draft',
  'inactive',
];

const SELECT_CLASS =
  'h-9 rounded-xl border border-n-weak bg-n-solid-1 px-2 text-sm text-n-slate-12 outline-none focus-visible:ring-2 focus-visible:ring-n-teal-9';
</script>

<template>
  <div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:flex-wrap">
    <input
      :value="search"
      type="search"
      class="h-9 min-w-0 flex-1 rounded-xl border border-n-weak bg-n-solid-1 px-3 text-sm text-n-slate-12 outline-none focus-visible:ring-2 focus-visible:ring-n-teal-9"
      :placeholder="$t('FLOW_AUTOMATIONS.INDEX.SEARCH_PLACEHOLDER')"
      :aria-label="$t('FLOW_AUTOMATIONS.INDEX.SEARCH_PLACEHOLDER')"
      @input="$emit('update:search', $event.target.value)"
    />

    <select
      :value="channel"
      :class="SELECT_CLASS"
      :aria-label="$t('FLOW_AUTOMATIONS.INDEX.FILTER.ALL_CHANNELS')"
      @change="$emit('update:channel', $event.target.value)"
    >
      <option value="">
        {{ $t('FLOW_AUTOMATIONS.INDEX.FILTER.ALL_CHANNELS') }}
      </option>
      <option v-for="option in availableChannels" :key="option" :value="option">
        {{ $t(`FLOW_AUTOMATIONS.INDEX.CHANNEL.${option}`) }}
      </option>
    </select>

    <select
      :value="status"
      :class="SELECT_CLASS"
      :aria-label="$t('FLOW_AUTOMATIONS.INDEX.FILTER.ALL_STATUS')"
      @change="$emit('update:status', $event.target.value)"
    >
      <option value="">
        {{ $t('FLOW_AUTOMATIONS.INDEX.FILTER.ALL_STATUS') }}
      </option>
      <option v-for="option in STATUSES" :key="option" :value="option">
        {{ $t(`FLOW_AUTOMATIONS.INDEX.HEALTH.${option}`) }}
      </option>
    </select>

    <select
      :value="folder"
      :class="SELECT_CLASS"
      :aria-label="$t('FLOW_AUTOMATIONS.INDEX.FILTER.ALL_FOLDERS')"
      @change="$emit('update:folder', $event.target.value)"
    >
      <option value="">
        {{ $t('FLOW_AUTOMATIONS.INDEX.FILTER.ALL_FOLDERS') }}
      </option>
      <option v-for="option in availableFolders" :key="option" :value="option">
        {{ option }}
      </option>
    </select>
  </div>
</template>
